<template>
  <div>
    <!-- 订单标签核对：仅供订单标签使用，不影响配送单标签核对。 -->
    <el-dialog :title="$t('message.labelComparison')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <div class="row">
          <div class="label">
            <input ref="codeInput" type="text" v-model="code" onfocus="this.select()"
              :placeholder="$t('message.tagCoding')" @keyup.enter="scan">
          </div>
          <div class="val">
            <el-button type="primary" @click="scan">{{ $t('message.entry') }}</el-button>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <li>{{ $t('message.scanningTime') }}</li>
            <li>{{ $t('message.scanBarCode') }}</li>
            <li>{{ $t('message.labelComparison') }}</li>
          </ol>
          <div class="list">
            <ul v-for="(item, index) in tableData" :key="item.id || index" :class="{ is_match: !item.is_match }">
              <li class="flex05">{{ index + 1 }}</li>
              <li>{{ item.created_at }}</li>
              <li>{{ item.code }}</li>
              <li>{{ item.is_match ? '匹配成功' : '未匹配' }}</li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      orderSn: '',
      orderDetailTagId: '',
      code: '',
      tableData: []
    }
  },
  watch: {
    dialogVisible(visible) {
      if (!visible) return
      this.code = ''
      this.getScanList()
      this.$nextTick(() => {
        if (this.$refs.codeInput) this.$refs.codeInput.focus()
      })
    }
  },
  methods: {
    // 打开当前订单标签的核对弹窗；历史按订单号查询，扫码按标签主键校验。
    open(orderSn, orderDetailTagId) {
      this.orderSn = orderSn
      this.orderDetailTagId = orderDetailTagId
      this.dialogVisible = true
    },
    // 扫码历史接口仅按订单号精确查询，不传订单标签主键。
    getScanList() {
      this.$api.orderApi.tagScanList({
        order_sn: this.orderSn,
        page: 1,
        pageSize: 9999
      }).then((res) => {
        this.tableData = res.data.data
      })
    },
    // 扫码校验成功后立即刷新历史列表，继续聚焦输入框便于连续扫码。
    scan() {
      const code = this.code.trim()
      if (!code) return
      this.$api.orderApi.tagScan({
        order_detail_tag_id: this.orderDetailTagId,
        code
      }).then(() => {
        this.code = ''
        this.getScanList()
        this.$nextTick(() => {
          if (this.$refs.codeInput) this.$refs.codeInput.focus()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      width: 250px;
      margin-right: 10px;
      line-height: 40px;

      input {
        width: 240px;
        height: 38px;
        padding-left: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
      }
    }

    .val {
      flex: 1;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol,
    ul {
      display: flex;
    }

    ul {
      padding: 0;
      border-bottom: 1px solid #edeff4;

      li {
        padding: 24px 0;
      }
    }

    .list {
      max-height: 500px;
      overflow-y: auto;
    }

    li {
      flex: 1;
      text-align: center;
      border-right: 1px solid #edeff4;

      &:last-child {
        border-right: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }
  }

  .is_match {
    color: #fff;
    background-color: red;

    li {
      font-size: 20px;
    }
  }
}
</style>
